import { useCallback, useMemo, useState } from 'react';
import { isInvokeFunctionMessage, isSetComponentPropsMessage, isSetComponentStateMessage, isValidMessage, messages } from '../../../common/messages';
import { useFunctionsManager } from './useFunctionsManager';
const getInitialComponentState = ({
  deferLoading = true,
  initiallyOpen = false
}) => ({
  isLoaded: !deferLoading,
  isOpen: initiallyOpen && !deferLoading,
  isReady: false,
  isDisabled: false,
  isFullscreenMode: false,
  style: {}
});
export const useCreateNavComponentManager = ({
  definition,
  embeddedContext,
  handshake: {
    metricsStartTime
  }
}) => {
  const initialProps = 'initialProps' in definition ? definition.initialProps : {};
  const [props, setProps] = useState(initialProps);
  const initialState = getInitialComponentState(definition);
  const [state, setState] = useState(initialState);
  const functionsManager = useFunctionsManager();
  const invokeCapability = useCallback((capability, args) => {
    const data = {
      source: definition.name,
      // Component name
      name: capability.getName(),
      args
    };
    embeddedContext.sendMessage(messages.INVOKE_CAPABILITY, data);
  }, [embeddedContext, definition.name]);
  const handleMessage = useCallback(message => {
    if (!isValidMessage(message)) {
      return;
    }
    if (isSetComponentPropsMessage(message)) {
      setProps(message.payload.props);
    } else if (isSetComponentStateMessage(message)) {
      setState(currentState => Object.assign({}, currentState, message.payload.updates));
    } else if (isInvokeFunctionMessage(message)) {
      const {
        payload: {
          fnName,
          args
        }
      } = message;
      functionsManager.notifyFunctionSubscribers(fnName, args);
    }
  }, [functionsManager]);
  const getComponentReadyMsg = useCallback(() => {
    return {
      receiveMessage: handleMessage,
      data: {
        name: definition.name
      }
    };
  }, [handleMessage, definition.name]);
  return useMemo(() => Object.assign({
    definition,
    invokeCapability,
    getComponentReadyMsg,
    props,
    state,
    metricsStartTime
  }, functionsManager), [definition, invokeCapability, getComponentReadyMsg, props, state, functionsManager, metricsStartTime]);
};